import moment from "moment";

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { CompanyFullName } from "../../../Defaults";
import { background, primary, white } from "../../../styles/colors";
import { StyledButton } from "../../../styles/StyledComponents";
import { useState } from "react";
import { fetchRecursivePaginatedData } from "../../../Regex";
import { Typography } from "@material-ui/core";

pdfMake.vfs = pdfFonts?.pdfMake?.vfs;

const billColumns = [
  { label: "Po No. - \n[Miller Bill No.]", key: "purchase_order_number", calculation: false },
  { label: "[Bill Date] - \n[Arrival Date]", key: "bill_date", calculation: false },
  { label: "Allotted Bags / Unloading Bags", key: "unloading_bags_number", calculation: false },
  { label: "Truck No.", key: "truck_number", calculation: false },
  { label: "Final Weight", key: "final_weight",  },
  { label: "CD Amount - [CD (%)]", key: "cash_discount",  },
  { label: "Brokerage Amount For Miller (₹)", key: "brokerage_amount_for_miller", calculation: "sum", decimals: 2 },
  { label: 'Final Rate (₹)', key: "final_rate", calculation: false },
  { label: "Miller Advance (₹)", key: "miller_advance", calculation: "sum", decimals: 2 },
  { label: "GST Amount - [Miller GST Charge]", key: "gst_charge",  },
  // { label: "RTGS Charge", key: "rtgs_charge",  },
  { label: "Miller Bill Amount (₹)", key: "bill_amount", calculation: "sum", decimals: 2 },
  { label: "Miller TDS Amount (₹) - [Miller TDS%]", key: "tds_amount",  },
  { label: "Other Deduction (₹)", key: "other_deduction", calculation: "sum", decimals: 2 },
  { label: "Final Amount (₹)", key: "miller_final_amount", calculation: "sum", decimals: 2 },
  { label: "Total Paid (₹) - [Payment Date]", key: "total_paid", calculation: "sum", decimals: 2 },
  { label: "Balance (₹) - [Due Date]", key: "balance", calculation: "sum", decimals: 2 },
];


const paymentSummaryColumns = [
  { label: "Date", key: "date" },
  { label: "Amount", key: "amount" },
  { label: "Other Deduction", key: "other_deduction" },
  { label: "RTGS Chgs", key: "rtgs_chgs" },
  { label: "Total Amount", key: "total_amount" },
];

function BillPDF(name, dataList, paymentSummary) {
  console.log("BillPDF", name, dataList, paymentSummary);

  const headers = billColumns.map((c) => c.label);

  const body = [
    // Header row
    headers.map((h) => ({
      text: h,
      bold: true,
      border: [true, true, true, true],
      fontSize: 6,
      alignment: "center",
    })),

    // Data rows
    ...dataList.map((row, i) =>
      headers.map((h) => ({
        text: String(row?.[h] == "" ? "" : Number(row?.[h]) == Number(0) ? 0 : row?.[h] ?? ""),
        fontSize:['BILL NO - [BILL DATE]'].includes(h) && Boolean(row?.[h]?.length >= 10) ? 5 : 6,
        border: [true, true, true, true],
        bold: i == dataList.length - 1,
        alignment: "center",
      }))
    ),
  ];

  const hasPaymentSummary = Boolean(paymentSummary?.payments?.length);
  const paymentSummaryHeaders = paymentSummaryColumns.map((c) => c.label);

  const paymentSummaryBody = hasPaymentSummary
    ? [
        paymentSummaryHeaders.map((h) => ({
          text: h,
          bold: true,
          border: [true, true, true, true],
          fontSize: 10,
          alignment: "center",
        })),

        ...paymentSummary.payments.map((row) =>
          paymentSummaryColumns.map((c) => ({
            text:
              c.key === "date"
                ? row?.date
                  ? moment(row.date).format("DD/MM/YYYY")
                  : ""
                : Number(row?.[c.key] || 0).toFixed(2),
            fontSize: 10,
            border: [true, true, true, true],
            alignment: "center",
          }))
        ),

        paymentSummaryColumns.map((c) => ({
          text: c.key === "rtgs_chgs" ? "GRAND TOTAL" : c.key === "total_amount" ? Number(paymentSummary?.totals?.grand_total || 0).toFixed(2) : "",
          bold: true,
          fontSize: 10,
          border: ["rtgs_chgs", "total_amount"].includes(c.key) ? [true, true, true, true] : [false, false, false, false],
          alignment: "center",
        })),

        paymentSummaryColumns.map((c) => ({
          text: c.key === "rtgs_chgs" ? "BALANCE" : c.key === "total_amount" ? Number(paymentSummary?.totals?.balance || 0).toFixed(2) : "",
          bold: true,
          fontSize: 10,
          border: ["rtgs_chgs", "total_amount"].includes(c.key) ? [true, true, true, true] : [false, false, false, false],
          alignment: "center",
        })),
      ]
    : [];

  const documentDefinition = {
    pageMargins: [5, 60, 5, 50],
    pageOrientation: "landscape",
    header: {
      stack: [
        {
          margin: [10, 15, 0, 0],
          columns: [
            {
              text: CompanyFullName.toUpperCase(),
              bold: true,
              fontSize: 16,
              alignment: "center",
              margin: [0, 0, 0, 0],
            },
          ],
        },
      ],
    },

    footer: function (currentPage, pageCount) {
      return {
        columns: [
          {
            width: "*",
            margin: [0, 0, 0, 0],
            stack: [
              {
                margin: [5, 0, 5, 0],
                table: {
                  widths: [250, "*", 210],
                  body: [
                    [
                      {
                        text:
                          "Page " + currentPage.toString() + "/" + pageCount,
                        alignment: "right",
                        colSpan: 3,
                        fontSize: 7,
                        border: [false, false, false, false],
                      },
                      {},
                      {},
                    ],
                    [
                      {
                        text: "Registered Off : : Balaji Rice Industries PVT Ltd. NEAR BUS STAND, MAIN ROAD, KHARORA, RAIPUR - 493225, CHATTISGARH (INDIA)",
                        alignment: "left",
                        colSpan: 3,
                        fontSize: 9,
                        bold: true,
                        border: [false, true, false, false],
                        margin: [-3, 0, -15, 0],
                      },
                      {},
                      {},
                    ],
                    [
                      {
                        text: "Fax: +91 771 4032240, Email : bri-team@smilebots.com Web:",
                        alignment: "left",
                        fontSize: 9,
                        border: [false, false, false, true],
                        margin: [-3, 0, 0, 0],
                      },
                      {
                        text: "www.balajirice.com",
                        alignment: "center",
                        color: "#F19A30",
                        fontSize: 9.8,
                        bold: true,
                        border: [false, false, false, true],
                      },
                      {
                        text: "This is computer generated",
                        alignment: "right",
                        fontSize: 9,
                        border: [false, false, false, true],
                        margin: [0, 0, -2, 0],
                      },
                    ],
                  ],
                },
              },
            ],
          },
        ],
      };
    },

    content: [
      {
        // Header table with miller and section title
        table: {
          widths: ["*"],
          body: [
            [
              {
                text: `${name} Reports (Miller)`,
                bold: true,
                fillColor: "#F19A30",
                fontSize: 12,
                alignment: "center",
                margin: [0, 0, 0, 5],
              },
            ],
            [
              {
                text: `Dispatch Details`,
                bold: true,
                fontSize: 11,
                alignment: "center",
                margin: [0, 5, 0, 5],
              },
            ],
          ],
        },
        margin: [0, 0, 0, 0],
      },
      {
        margin: [0, 0, 0, 0],
        table: {
          headerRows: 1,
          widths: Array(headers.length).fill("auto"),
          // [40, 48, 50, 50, 35, 35, 40, 35, 35, 40, 50, 35, 40, 45, 45, 45, 45,],
          body: body,
        },
      },
      ...(hasPaymentSummary
        ? [
            {
              text: "Payment Summary",
              bold: true,
              fontSize: 11,
              alignment: "center",
              margin: [0, 5, 0, 15],
              pageBreak: "before",
            },
            {
              columns: [
                { width: "*", text: "" },
                {
                  width: "auto",
                  table: {
                    headerRows: 1,
                    widths: Array(paymentSummaryHeaders.length).fill("auto"),
                    body: paymentSummaryBody,
                  },
                },
                { width: "*", text: "" },
              ],
            },
          ]
        : []),
    ],

    styles: {
      basicLeft: {
        color: "#000",
        fontSize: 6,
        alignment: "left",
      },
      basicRight: {
        color: "#000",
        fontSize: 6,
        alignment: "right",
      },
      basicCenter: {
        color: "#000",
        fontSize: 6,
        alignment: "center",
      },
      basicLeftBold: {
        color: "#000",
        bold: true,
        fontSize: 6.5,
        alignment: "left",
      },
      basicCenterBold: {
        color: "#000",
        bold: true,
        fontSize: 6.5,
        alignment: "center",
      },
    },
  };

  pdfMake.createPdf(documentDefinition).open();
}

export default function BillPDFButton(props) {
  const [pdfData, setPdfData] = useState(null);
  const [clicked, setClicked] = useState(false);
  const [fetchReportProgress, setFetchReportProgress] = useState(0);

  const handleCountStateUpdate = (data) => {
    setFetchReportProgress(data);
  };

  const fetcBillPDF = () => {
    setClicked(true);
    fetchRecursivePaginatedData(
      "get",
      "arrival/miller-accounts/download",
      { miller_id: props.millerId },
      null,
      handleCountStateUpdate
    ).then(({ responseDataList, paymentSummary }) => {
      if (responseDataList.length > 0) {
        let cleanedData = [];
        console.log(responseDataList);

        let formattedBills =  []
        let column = billColumns
        formattedBills = responseDataList.map((item) => {
          let row = {};
          
          column.forEach((col) => {
            
            let value = Number(item[col.key]) == Number(0) ? 0 : item[col.key];

            // console.log(col.key, item[col.key], Number(item[col.key]) == Number(0), value);

            // format bill date
            if (col.key === "dispatch_date") {
              value = value ? moment(value).format("ddd, MMM Do YYYY") : "";
            }

            if(col.key == 'unloading_bags_number'){
              value = value ? (item?.dispatched_bags + " / " + item["unloading_bags_number"]) : "";
            }

            if (col.key === "purchase_order_number") {
              value = `${value}\n\n${item?.["bill_number"] ? item["bill_number"] : ""}`
            }
            if (col.key === "bill_date") {
              value = `${item?.["bill_date"] ? (moment(item["bill_date"]).format("DD/MM/YYYY")) : ""}\n\n${item?.["arrival_date"] ? (moment(item["arrival_date"]).format("DD/MM/YYYY")) : ""}`
            }

            if (col.key === "tds_amount") {
              value = `${value || "0.00"}\n(${item?.["miller_tds"] || "0.00"} %)`
            }
            if (col.key === "balance") {
              value = `${value || "0.00"}\n${item?.["due_date"] ? (moment(item?.["due_date"]).format("DD/MM/YYYY")) : ""}`
            }
            if (col.key === "total_paid") {
              value = `${value || "0.00"}\n${item?.["last_payment_date"] ? (moment(item?.["last_payment_date"]).format("DD/MM/YYYY")) : ""}`
            }
            if (col.key === "cash_discount") {
              value = `${value || "0.00"}\n(${item?.["discount_percentage"] || "0.00"} %)`
            }
            if (col.key === "gst_charge") {
              value = `${value || "0.00"}\n(${item?.["gst_percentage"] || "0.00"} %)`
            }

            if(col.key === "final_weight" || col.key === "port_net_weight"){
              value = value ? String(Number(value || 0).toFixed(3)) + " " + item?.po_unit  : "";
            }

            row[col.label] = col.decimals && !['cash_discount', 'gst_charge', 'tds_amount', 'balance', 'total_paid' ].includes(col.key) 
            ? Number(value || 0).toFixed(col.decimals || 0) : value || "";
          });
          return row;
        });

        const totalRow = column.reduce((acc, col) => {
          console.log(formattedBills, col);
          if (col.calculation === "sum") {
            if(col.key == 'balance'){
              acc[col.label] = Number(paymentSummary?.totals?.balance || 0).toFixed(col.decimals || 0);
              console.log(acc, paymentSummary);
            }else{
              const total = formattedBills?.reduce(
                (sum, item) => sum + (Number(item[col.label]) || 0),
                0
              );
              acc[col.label] = Number(total).toFixed(col.decimals || 0);
            }
          } else if (col.label === "Po No.") {
            acc[col.label] = "Total"; // place label here
          } else {
            acc[col.label] = "";
          }
          return acc;
        }, {});

        formattedBills.push(totalRow);

        setClicked(false);
        setPdfData(formattedBills);
        BillPDF(props.brokerName, formattedBills, paymentSummary);
      }
    });
  };

  return (
    <StyledButton
      name={
        clicked ? (
          <Typography
            style={{
              fontFamily: "Poppins",
              // color: "#4B87C5",
              color: primary,
              fontSize: "0.9rem",
            }}
            variant="body1"
            component="div"
            // color="text.secondary"
          >
          {console.log(fetchReportProgress)}
            {`${Math.round(
              !Boolean(fetchReportProgress) ? 0 : fetchReportProgress
            )}%`}
          </Typography>
        ) : (
          <Typography
            style={{
              fontFamily: "Poppins",
              fontSize: "0.9rem",
              textTransform: "uppercase",
            }}
          >
            .PDF
          </Typography>
        )
      }
      background={white}
      padding={"2px 6px"}
      fontSize={"0.8rem"}
      border={"1px solid rgb(241, 154, 48)"}
      boxShadow={"none"}
      disabled={props.tableList?.length <= 0 || clicked}
      onClick={() => {
        console.log("PDF", props.tableList);
        fetcBillPDF();
        // this.generateBillPDF()
        // BillPDF(tableList, generatePdfList(tableList));
      }}
    />
  );
}
